import { render, staticRenderFns } from "./OnSign.vue?vue&type=template&id=18c26d69&"
import script from "./OnSign.vue?vue&type=script&lang=js&"
export * from "./OnSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports